module.exports = __webpack_public_path__ + "static/media/0.6b689b02.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/mouth/0.png
// module id = 1338
// module chunks = 0